"use client";
import { IconCalendar1 } from "@/app/_components/icons";
import AddToMyFavoriteIconButton from "@/app/_components/share/AddToMyFavoriteIconButton";
import ApplyJob from "@/app/_components/share/ApplyJob";
import ImageSlider from "@/app/_components/share/ImageSlider";

import { getJobDetail } from "@/services/api/job";
import { FAV_TYPE } from "@/services/constants/global";
import { CORPORATE_DETAIL_PATH } from "@/services/constants/routerPath";
import { formatDate } from "@/services/utils/formatter";
import {
  Card,
  Divider,
  HStack,
  Link,
  Show,
  Skeleton,
  Stack,
  Text,
} from "@chakra-ui/react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

export default function RecruitmentDetailSideCard({ id }) {
  const { i18n } = useTranslation();
  const { data, isLoading } = useQuery("recruitmentDetail", () =>
    getJobDetail(id)
  );
  return (
    <Card
      id={get(data, "_id")}
      variant="solid"
      rounded="lg"
      minW={{ base: "full", lg: "xs" }}
      maxW={{ base: "full", lg: "xs" }}
      px={3}
      pt={3}
      pb={6}
      boxShadow="0px 6px 20px 0px rgba(121, 121, 121, 0.10)"
      pos={{ base: "relative", lg: "sticky" }}
      top={{ base: "unset", lg: 10 }}
    >
      <Stack gap={6}>
        <Stack gap={3} direction="column">
          {isLoading ? (
            <Skeleton h={100} w="full" />
          ) : (
            <ImageSlider photos={get(data, "corporate.logo")} />
          )}
          <Stack align="center" justify="center">
            {isLoading ? (
              <Skeleton w={24} h={4} />
            ) : (
              <Text as="strong" fontSize={{ base: "sm", lg: "large" }}>
                {get(data, "recruitmentName")}
              </Text>
            )}
            <HStack>
              {isLoading ? (
                <Skeleton w={24} h={3} />
              ) : (
                <Link
                  href={CORPORATE_DETAIL_PATH + get(data, "corporate._id")}
                  fontSize="xs"
                >
                  {get(data, "companyName")}
                </Link>
              )}
              {isLoading ? (
                <>
                  <Divider orientation="vertical" h={4} />
                  <Skeleton w={24} h={3} />
                </>
              ) : (
                <>
                  {get(data, "brand") && (
                    <>
                      <Divider orientation="vertical" h={4} />
                      <Text fontSize="xs">
                        {get(data, "brand.name")[i18n.language]}
                      </Text>
                    </>
                  )}
                </>
              )}
            </HStack>

            <Show below="lg">
              {isLoading ? (
                <Skeleton w={24} h={4} />
              ) : (
                <Text fontSize={12}>{formatDate(get(data, "endPeriod"))}</Text>
              )}
            </Show>
          </Stack>
        </Stack>
        <HStack
          py={2}
          textAlign="center"
          bgColor="faded"
          rounded="lg"
          justify="center"
          gap={2}
        >
          <IconCalendar1 />
          {isLoading ? (
            <Skeleton w={24} h={4} />
          ) : (
            <Text>{formatDate(get(data, "endPeriod"))}</Text>
          )}
        </HStack>
        <HStack spacing={4}>
          <AddToMyFavoriteIconButton
            id={id}
            isFavorite={get(data, "isFavourite")}
            favoriteType={FAV_TYPE.JOB}
            pos={{ base: "absolute", lg: "unset" }}
            top={3}
            right={3}
          />
          <ApplyJob
            w="full"
            isDisabled={get(data, "isApplied")}
            jobId={get(data, "_id")}
            jobTitle={get(data, "recruitmentName")}
            jobPositions={get(data, "jobPositions")}
          />
        </HStack>
      </Stack>
    </Card>
  );
}
